import { BlogSection } from '../../components';

const Blog = () => {
  return (
    <div>
      <BlogSection />
    </div>
  );
};

export default Blog;
